import axios from 'axios';
import { MOBILE_MENU_CLOSE, MOBILE_MENU_OPEN, GET_MOBILE_LINKS } from './mobileMenuActionTypes';


export function mobileMenuOpen() {
    return { type: MOBILE_MENU_OPEN };
}

export function mobileMenuClose() {
    return { type: MOBILE_MENU_CLOSE };
}

export function mobileMenuUpdateLinks(links) {
    return { 
        type: GET_MOBILE_LINKS,
        payload: links
        
    };
}


export const mobileMenuGetLinks = () => {
    return dispatch => {
      return axios.get('https://catalog.tstmetal.site/categories', { responseType: 'json' })
        .then(res => {
          // 1) Берём либо res.data.category_list (старый вариант), 
          //    либо сам массив (новый вариант)
          let raw = Array.isArray(res.data)
            ? res.data
            : res.data.category_list;
  
          // 2) Если пришёл единичный объект ROOT — спускаемся в его children
          if (
            Array.isArray(raw) &&
            raw.length === 1 &&
            raw[0].id === 'ROOT' &&
            Array.isArray(raw[0].children)
          ) {
            raw = raw[0].children;
          }
  
          // 3) Диспатчим уже чистый массив ссылок
          dispatch(mobileMenuUpdateLinks(raw));
        })
        .catch(err => {
          console.error("Failed to load mobile links:", err);
        });
    };
  };
